module.exports = __webpack_public_path__ + "static/media/send.7b64d161.svg";